import { type ToastItem, useToastStore } from "~/stores/ui/toaststore";
import { useUserStore } from "~/stores/userstore";
import { useCompanyStore } from "~/stores/companystore";

export default defineNuxtRouteMiddleware(async (_unused_to, _unused_from) => {
  console.debug("userHasCompany middleware");
  const userStore = useUserStore();
  const companyStore = useCompanyStore();

  await companyStore.ensureLoaded();

  if (!companyStore.userHasCompany) {
    console.warn(`User has no company.`);
    const toastStore = useToastStore();
    toastStore.addToast({
      id: self.crypto.randomUUID(),
      title: `Company Registration`,
      body: `Please register or join a company first.`,
      appendToast: false,
      position: "top-center",
      variant: "info",
      solid: true,
    } as ToastItem);
    return navigateTo(
      "/users/" + userStore.authUserUuid + "/company-registration",
    );
  }
});
